<!--
 * @Author: awu
 * @Date: 2020-11-12 23:15:13
 * @LastEditors: awu
 * @LastEditTime: 2020-12-08 23:03:56
 * @Description: file content
-->
<template>
    <div class="product">
        <div class="backHome" @click="backHome">
            <img src="../../assets/user/close.png" alt="" />
        </div>
        <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
            <swiper-slide style="position: relative" v-for="(item, index) in swiperSlide" :key="index">
                <div class="box">
                    <div class="flip">
                        <div class="flip-box">
                            <div class="flip-item flip-item-front" >
                                <div class="front">
                                    <div  class="headerImg">
                                        <img class="himg" src="~statics/profile.png" alt="">
                                    </div>
                                    <p>{{item.name}}</p>
                                    <span>{{item.post}}</span>
                                </div>
                            </div>
                            <div class="flip-item flip-item-back" >
                                <div class="behind">
                                    <h2>{{item.name}}</h2>
                                    <p>{{item.post}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" @click="prev()" slot="button-prev">
            <img v-show="leftArrowFlag" src="../../assets/left.png" alt="" />
            <img v-show="!leftArrowFlag" src="../../assets/noLeft.png" alt="" />
        </div>
        <div class="swiper-button-next" @click="next()" slot="button-next">
            <img v-show="rightArrowFlag" src="../../assets/right.png" alt="" />
            <img v-show="!rightArrowFlag" src="../../assets/noRight.png" alt="" />
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {
            swiperOptions: {
                //设置点击箭头
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    disabledClass: "my-button-disabled"
                },
                loop: false,
                slidesPerView: 3,
                lidesPerGroup: 2
            },
            overIndex: -1,
            slideNum: 3,
            leftArrowFlag: false,
            rightArrowFlag: false,
            swiperSlide: [],
            exhibition_id: ''
        };
    },
    mounted() {
        this.exhibition_id = this.$route.query.exhibition_id;
        this.getGuestInfo(this.exhibition_id);
    },
    methods: {
        backHome() {
            this.$router.push(`/area/bigconference?exhibition_id=${ this.exhibition_id }`);
            this.$root.$emit("close");
        },
        prev() {
            this.swiper.slidePrev();
            this.slideNum--;
            if (this.slideNum <= 3) {
                this.slideNum = 3;
            }
        },
        next() {
            this.swiper.slideNext();
            this.slideNum++;
            if (this.slideNum >= this.swiperSlide.length) {
                this.slideNum = this.swiperSlide.length;
            }
        },
        mouseOver($e, index) {
            this.overIndex = index;
        },
        mouseOut($e) {
            this.overIndex = -1;
        },
        getGuestInfo(){
            api.getGuestInfo({ exhibition_id: this.exhibition_id })
            .then(res=>{
                console.log(res)
                if(res.res==1){
                    this.swiperSlide = res.list
                }
            })
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        }
    },
    watch: {
        slideNum(value) {
            if (value <= 3) {
                this.leftArrowFlag = false;
            }
            this.leftArrowFlag = value <= 3 ? false : true;
            this.rightArrowFlag = value >= this.swiperSlide.length ? false : true;
        },
        swiperSlide(value) {
            if (value.length <= 3) {
                this.leftArrowFlag = false;
                this.rightArrowFlag = false;
            } else {
                this.leftArrowFlag = false;
                this.rightArrowFlag = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.product {
    width: 788px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
    border-radius: 30px;
    box-sizing: border-box;
    padding: 53px 20px;
    .swiper {
        width: 697px;
        height: 247px;
        background-color: #fff;
        box-sizing: border-box;
        padding: 0px;

        .flip {
            transform: translate3d(0, 0, 0);
            width: 100%;
            height: 100%;
        }
        .flip-box {
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
        }
        .flip-item {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            transition: all 0.5s ease-in-out;
            transform-style: preserve-3d;
            backface-visibility: hidden;
            box-sizing: border-box;
        }
        .flip-item img {
            width: 70px;
            height: 70px;
            border-radius: 100%;
            margin: 32px auto;
            display: block;
        }
        .flip-item-text {
            position: absolute;
            bottom: 8px;
            left: 0;
            width: 100%;
            text-align: center;
            color: #fff;
        }
        .flip-item-front {
            transform: rotateX(0deg);
            z-index: 2;
            /*background:#fff;
	*/
        }
        .flip-item-back {
            transform: rotateX(180deg);
            z-index: 1;
            /*background:#009fff;
	*/
        }
        .flip-item-back .flip-item-text {
            color: #fff;
        }
        .flip-box:hover .flip-item-front {
            z-index: 1;
            transform: rotateX(180deg);
        }
        .flip-box:hover .flip-item-back {
            z-index: 2;
            transform: rotateX(0deg);
        }
        .flip-item-bling {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 200px;
            height: 200px;
            margin-top: -100px;
            margin-left: -100px;
            z-index: -1;
        }
        .flip-box:hover .flip-item-bling {
            transform: translate3d(0, 0, 0);
            animation: rotate infinite 4s linear;
        }
        @keyframes rotate {
            0% {
                transform-origin: center;
                transform: rotate3d(0, 0, 1, 0deg);
            }
            100% {
                transform-origin: center;
                transform: rotate3d(0, 0, 1, 360deg);
            }
        }

        .box {
            width: 217px;
            height: 247px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 5px;
            cursor: pointer;
            .behind {
                width: 100%;
                height: 100%;
                background: #e6ecf3;
                border-radius: 5px;
                box-sizing: border-box;
                padding: 12px 13px 10px;
                position: absolute;
                top: 0;
                left: 0;
                > h2 {
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #09468c;
                    line-height: 22px;
                    text-align: center;
                }
                > p {
                    width: 100%;
                    height: 197px;
                    color: #789abf;
                    font-size: 11px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    line-height: 21px;
                    overflow-y: auto;
                    text-align: justify;
                    box-sizing: border-box;
                    padding-right: 2px;
                }
                > p::-webkit-scrollbar {
                    width: 1px;
                    height: 100%;
                    background-color: #fff;
                }
                > p::-webkit-scrollbar-thumb {
                    width: 1px;
                    height: 20%;
                    background: #09468c;
                    border-radius: 4px;
                }
            }
            .front {
                width: 184px;
                height: 210px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background: #3a6ba3;
                border-radius: 5px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                .headerImg {
                    width: 110px;
                    height: 110px;
                    border-radius: 50%;
                    margin-top: 20px;
                    /* margin-bottom: 10px; */
                    position: relative;
                    .himg{
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        position: absolute;
                        top: 0px;
                        margin: 0;
                        left: 0;
                    }
                }
                > p {
                    font-size: 20px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 28px;
                    margin-bottom: 7px;
                }
                > span {
                    font-size: 12px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #ffffff;
                    line-height: 16px;
                    width: 90%;
                    text-align: center;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }
        .over {
            transform: scale(1.1); //设置缩放比例
            -ms-transform: scale(1.1);
            -webkit-transform: scale(1.1);
            -o-transform: scale(1.1);
            -moz-transform: scale(1.1);
            transition-duration: 0.2s;
            .boxBot {
                background: #09468c;
                color: #ffffff;
            }
        }
        .noover {
            transform: scale(1); //设置缩放比例
            -ms-transform: scale(1);
            -webkit-transform: scale(1);
            -o-transform: scale(1);
            -moz-transform: scale(1);
            transition-duration: 0.2s;
        }
    }
    .my-button-disabled {
        opacity: 0.2;
    }
}
.backHome {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 21px;
    right: 21px;
    cursor: pointer;
    border-radius: 50%;
    > img {
        width: 100%;
        height: 100%;
    }
}
.backHome:hover {
    background-color: #e8eef4;
}
</style>


// WEBPACK FOOTER //
// src/views/conference/bigGuest.vue